import { IdentityDto } from './../shared/identity.dto';
import { EntityDto } from './../entity/entity.dto';
import { AgentDataDto } from './agent-data.dto';
import { AccountAttributeDto } from './attribute.dto';

export class AccountDto {
  identity: IdentityDto;
  entity: EntityDto;
  type: string;
  country: string;
  legalEntity: string;
  accountCode: string;
  category: string;
  biller: string;
  agentData?: AgentDataDto[] = [];
  merchantOfRecordAccount?: string;
  payable?: AccountAttributeDto;
  receivable?: AccountAttributeDto;
  campaigns?: string[];

  errors?: any[];

  constructor(d?: AccountDto) {
    if (!d) {
      return;
    }

    this.identity = d.identity;
    this.entity = d.entity;
    this.type = d.type;
    this.country = d.country;
    this.legalEntity = d.legalEntity;
    this.accountCode = d.accountCode;
    this.biller = d.biller;
    this.category = d.category;
    this.campaigns = d.campaigns;
    this.agentData = (d.agentData || []).map(i => new AgentDataDto(i));

    if (d.merchantOfRecordAccount) {
      this.merchantOfRecordAccount = d.merchantOfRecordAccount;
    }

    if (d.payable) {
      this.payable = new AccountAttributeDto(d.payable);
    }

    if (d.receivable) {
      this.receivable = new AccountAttributeDto(d.receivable);
    }

    if (d.errors) {
      this.errors = d.errors;
    }
  }
}
